import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import { fetchReservationUpcomingEvents } from '../../sagas/routines';
import {
  clearReservationUpcomingEvents,
  reservationUpcomingEventsOnChangePage,
  reservationUpcomingEventsOnChangeOrder
} from '../../actions/upcoming-events';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'outreachOn:asc'
};

const clearReservationUpcomingEventsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const reservationUpcomingEventsOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const reservationUpcomingEventsOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchReservationUpcomingEvents),
  ...clearReservationUpcomingEventsHandler(clearReservationUpcomingEvents),
  ...reservationUpcomingEventsOnChangePageHandler(
    reservationUpcomingEventsOnChangePage
  ),
  ...reservationUpcomingEventsOnChangeOrderHandler(
    reservationUpcomingEventsOnChangeOrder
  )
});
